<template>
<div :class="isForm?'':$style['show-goods-table']">
    <wt-table :list="goodsList" :labels="labels">
        <template slot="before">
         <el-table-column label="商品/价格"  minWidth="150">
            <template slot-scope="scope">
                <div :class="$style['goods-price-name']">
                    <div :class="$style['banner-picture-div']">
                    <pt-img :class="$style['banner-picture']"
                    :src="scope.row.goodsDTO.goodsData.mainPicture" styleName="mall-goods-banner-pictures"></pt-img>
                    </div>
                    <div :class="firstColumnPrice?$style['goods-name-price']:$style['no-price-name']">
                        <div> {{scope.row.goodsDTO.goodsData.name}}</div>
                        <div v-if="firstColumnPrice">{{scope.row.final_price}}</div>
                    </div>
                </div>
            </template>
            </el-table-column>
            <el-table-column label="库存" v-if="showStockQuantity">
                <template slot-scope="scope">
                {{scope.row.goodsOtherInfoDTO&&scope.row.goodsOtherInfoDTO.stockQuantity}}
                </template>
            </el-table-column>
        </template>
        <slot/>
    </wt-table>
</div>
</template>
<script>
export default {
  props: {
    // 首列是否显示价格
    firstColumnPrice: {
      type: Boolean,
      default: true
    },
    goodsList: {
      type: Array,
      default: function () {
        return []
      }
    },
    isForm: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Array,
      default: function () {
        return []
      }
    },
    haveInfo: {
      type: Boolean,
      default: false
    },
    infoFiled: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

      showStockQuantity: false
    }
  },
  created () {
    this.showStockQuantity = this.$store.getters.showStockQuantity
  }

}
</script>
<style module lang="less">
@import "~less/var";
.show-goods-table{
    padding: 20px 40px 30px;
    box-sizing: border-box;
    background: @subTitleBackground;
    :global
    .el-table{
        *{
            background-color: @subTitleBackground;
        }
        tr{
            th,td{
                border-bottom:1px solid #C4C8D2;
            }
        }
    }
    :global
    table{
        tr{
    display: table-row;
        }
    }
}
.goods-price-name{
    display: flex;
    line-height: inherit;
    width: 100%
}
.goods-name-price{
    // display: flex;
    padding-left: 10px;
    flex-direction: column;
    display: -webkit-inline-box;
    white-space:initial;
    justify-content: space-between;
    :global
    div{
        word-break:break-word
    }
}
.no-price-name{
    display: flex;
    padding-left: 10px;
    align-items: center
}
.banner-picture-div{
    display: flex;
    justify-content: center;
    align-items: center;
}
.banner-picture{
   border-radius: 5px;
}
</style>
